import styled from 'styled-components';

export const Title = styled.h3`
  ${props => props.theme.typography.h4};
  font-family: ${props => props.theme.typography.fontFamily};
  color: ${props => props.theme.colors.background};
`;
